export const INIT_AUTH = 'INIT_AUTH';
export const START_LOGIN = 'START_LOGIN';
export const SIGN_IN_ERROR = 'SIGN_IN_ERROR';

export const SIGN_IN_SUCCESS = 'SIGN_IN_SUCCESS';
export const SIGN_IN_EMAIL_PASSWORD_SUCCESS = 'SIGN_IN_EMAIL_PASSWORD_SUCCESS';

export const START_SIGN_UP = 'START_SIGN_UP';
export const SIGN_UP_SUCCESS = 'SIGN_UP_SUCCESS';
export const SIGN_UP_ERROR = 'SIGN_UP_ERROR';

export const SIGN_OUT_SUCCESS = 'SIGN_OUT_SUCCESS';



// WEBPACK FOOTER //
// ./src/core/auth/action-types.js